import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendGAPageView, hotjarStateChange } from "../consent/consentManager";
import { useConsent } from "../consent/ConsentContext";

export default function RouteTracking() {
  const location = useLocation();
  const { consent } = useConsent();

  useEffect(() => {
    const path = location.pathname + location.search + location.hash;
    if (consent.analytics) {
      sendGAPageView({ path });
      hotjarStateChange(path);
    }
  }, [location, consent.analytics]);

  return null;
}
